export const HIERARCHY_REQUEST = "HIERARCHY_REQUEST";
export const HIERARCHY_SUCCESS ='HIERARCHY_SUCCESS';
export const HIERARCHY_FAIL = 'HIERARCHY_FAIL';
